import React, {useEffect} from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Textarea,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";

const SMSCampaignModal = ({
  isOpen,
  onClose,
  onAddCampaignOpen,
  toast,
  textAreaRef,
  customizedTemplate,
  setCustomizedTemplate,
  campaignCategory,
  setIsConfigVisible,
  handleFocus,
  handleBlur,
  resetData,
  isEditing,
  setIsEditing,
  campaignType,
  saveCampaign
}) => {
  useEffect(() => {
      if (isOpen && campaignType === 'reminder') {
        if (campaignCategory === 'Confirmation'){
          setCustomizedTemplate((prevTemplate) => ({
            ...prevTemplate,
            template: {
              ...prevTemplate.template,
              sms: {
                ...prevTemplate.template.sms,
                template: prevTemplate.template.sms.template + ' Please click on the following link to confirm: {{.ConfirmationLink}}',
              },
            },
          }));
        }
      }
    }, [isOpen, campaignCategory, setCustomizedTemplate]);
  return (
    <Modal zIndex="1400" isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} blockScrollOnMount={false} // Add this line
      trapFocus={false}>
      <ModalOverlay />
      <ModalContent maxWidth="600px">  {/* Set the width here */}
        <ModalHeader>Text Message Content</ModalHeader>
        <ModalCloseButton
          onClick={() => {
            onClose();
            resetData();
          }}
        />
        <ModalBody>
          <FormControl>
            <FormLabel>Message Template</FormLabel>
            <Textarea
              name="smsTemplate"
              ref={textAreaRef}
              value={customizedTemplate?.template?.sms?.template}
              onChange={(e) => {
                setCustomizedTemplate({
                  ...customizedTemplate,
                  template: {
                    ...customizedTemplate.template,
                    sms: {
                      ...customizedTemplate.template.sms,
                      template: e.target.value,
                    },
                  },
                });
              }}
              onFocus={() => handleFocus(["template", "sms", "template"])}
              onBlur={handleBlur}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>This will be added to the end of the message:</FormLabel>
            <Text mx={2}>
              Reply “UNSUBSCRIBE” to opt out. </Text>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              onClose();
              if (!isEditing) {
                onAddCampaignOpen();
              } else {
                setIsEditing(false);
              }
            }}
          >
            Back
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={async () => {
              if (!customizedTemplate.template.sms?.template) {
                toast({
                  title: "Error",
                  description: "The message template cannot be empty.",
                  status: "error",
                  duration: 5000,
                  isClosable: true,
                });
                return;
              }
              onClose();
              setIsConfigVisible(true);
              if (!isEditing) {
                setIsConfigVisible(true);
              } else {
                await saveCampaign();
                setIsEditing(false);
              }
            }}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SMSCampaignModal;
